<template>
    <WarnTips :show="true" :showVipText="!vip" :normalText="descriptionStr" :vipText="$t('tobuy')" :triggerStr="'recycleTimeFloat'">
        <template #icon>
            <img v-if="vip" src="@/home/assets/pcview/tips-vip.svg" alt="" />
        </template>
    </WarnTips>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import WarnTips from "./WarnTips.vue";

    @Component({
        components: {
            WarnTips,
        },
    })
    export default class recycleWarn extends Vue {
        get descriptionStr() {
            return this.vip ? this.$t("vipTips") : this.$t("description");
        }
        created() {}
        mounted() {}
    }
</script>
<i18n>
{
    "zh": {
        "description": "非会员仅可还原7天内删除的文件",
        "tobuy": "开通VIP",
        "vipTips": "VIP可还原90天内删除的文件"
    },
    "en": {
        "description": "With the Free version you can only restore documents from the last 7 days.",
        "tobuy": "Upgrade to Premium",
        "vipTips": "Restore documents from the last 90 days"
    },
    "fr": {
        "description": "Avec la version gratuite, vous ne pouvez restaurer que les documents des sept derniers jours. ",
        "tobuy": "Passez à la version Premium pour restaurer les documents des 90 derniers jours.",
        "vipTips": "Supprimer définitivement après 90 jour(s)"
    },
    "de": {
        "description": "Mit der kostenlosen Version können Sie nur Dokumente der letzten 7 Tage wiederherstellen. ",
        "tobuy": "Führen Sie ein Upgrade auf Premium durch, um Dokumente der letzten 90 Tage wiederherstellen zu können.",
        "vipTips": "Dauerhaft gelöscht nach 90 Tagen"
    },
    "jp": {
        "description": "無料バージョンでは、過去 7 日間のドキュメントのみを復元できます。",
        "tobuy": "過去 90 日間のドキュメントを復元するには、プレミアムにアップグレードしてください。",
        "vipTips": "90日後に完全に消去"
    },
    "es": {
        "description": "Con la versión Gratis solo puede restaurar documentos de los últimos 7 días. ",
        "tobuy": "Actualice a Premium para restaurar documentos de los últimos 90 días.",
        "vipTips": "Eliminado de forma permanente después de 90 días"
    },
    "pt": {
        "description": "Com a versão gratuita, você só pode restaurar documentos dos últimos 7 dias. ",
        "tobuy": "Atualize para a versão Premium para restaurar documentos dos últimos 90 dias.",
        "vipTips": "Excluído permanentemente após 90 dias"
    },
    "it": {
        "description": "Con la versione gratuita puoi ripristinare solo i documenti degli ultimi 7 giorni. ",
        "tobuy": "Passa alla versione Premium per ripristinare i documenti degli ultimi 90 giorni",
        "vipTips": "Eliminato in modo permanente dopo 90 giorni"
    },
    "tw": {
        "description": "使用免費版本時，您只能還原過去 7 天內的文件。",
        "tobuy": "升級至 Premium 即可還原過去 90 天內的文件。",
        "vipTips": "VIP可还原90天内删除的文件"
    },
    "kr": {
        "description": "무료 버전을 사용하면 지난 7일 동안의 문서만 복원할 수 있습니다. ",
        "tobuy": "프리미엄으로 업그레이드하면 지난 90일 동안 문서를 복원할 수 있습니다.",
        "vipTips": "VIP可还原90天内删除的文件"
    },
    "id": {
        "description": "Dengan versi Gratis ini, Anda hanya dapat memulihkan dokumen dari 7 hari terakhir. ",
        "tobuy": "Tingkatkan ke Premium untuk memulihkan dokumen dari 90 hari terakhir",
        "vipTips": "VIP可还原90天内删除的文件"
    }
}
</i18n>
